<ion-button [fill]="fill" [color]="color" size="small" class="button-circle ion-no-margin" [disabled]="disabled" (click)="onClick($event)">
  <ion-icon [name]="icon" slot="icon-only"></ion-icon>
</ion-button>
